import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const QUESTIONS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'];

export default function FaqAccordion() {
  const { t } = useLanguage();
  const [open, setOpen] = useState(-1);

  return (
    <section id="sss" className="bg-[#0d213f] py-16 md:py-20 px-6" data-testid="landing2-faq">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-[34px] font-black text-[#F7F5F0] text-center mb-8">
          {t('landing2.faq.title')}
        </h2>
        <div className="flex flex-col gap-3">
          {QUESTIONS.map((key, i) => {
            const isOpen = open === i;
            return (
              <div key={key} className="border border-white/10 rounded-2xl overflow-hidden bg-[#0b1c38]">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full text-left bg-transparent border-none text-[#F7F5F0] text-[16px] font-bold px-[22px] py-5 cursor-pointer flex items-center justify-between gap-4 hover:bg-white/[0.03] transition-colors"
                  data-testid={`faq-toggle-${key}`}
                >
                  {t(`landing2.faq.${key}`)}
                  <ChevronDown
                    size={20}
                    className="text-[#C9A227] flex-shrink-0 transition-transform duration-300"
                    style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
                    aria-hidden="true"
                  />
                </button>
                {isOpen && (
                  <div className="px-[22px] pb-5 text-[15px] leading-relaxed text-[#b9c4d4]">
                    {t(`landing2.faq.a${key.slice(1)}`)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
